import React from 'react';
import Slider from 'react-slick';
import Fade from "react-reveal/Fade";
import Slide from "react-reveal/Slide";



function SliderTwo() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 1500,
    autoplay: true,
    autoplaySpeed: 7000,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll:1,
    center:false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 575,
        settings: {
          sidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        }
      }
    ]
  }

  // useEffect(()=>{
	// new WOW.WOW({
  //   boxClass: 'wow',
	// 	animateClass: 'animated',
	// 	offset: 0,
	// 	mobile: false,
	// 	live: true,
  //   loop:Infinity,
  // }).init();

  // },[])

  return (


<section className="slider-area">
            <Slider className="slider-active" {...settings}>
              <div className="single-slider slider-bg slider-style-two">
                <div className="container-fluid container-full-padding">
                  <div className="row">
                    <div className="col-xl-6 col-lg-7 col-md-11">
                      <div className="slider-content ">
                        <Fade up delay={.4000}>
                        <h6>Ask yourself</h6>
                        </Fade>
                        
                        <Fade up delay={.5000}> 
                        <h2>Can <span>One</span> Boy</h2>
                        </Fade>
                        <Fade up delay={.5000}>
                        <h5>and a Time Machine stand against a high-tech villain from the future? </h5>
                        </Fade >
                       
                        <Fade up delay={.4000}>
                        </Fade>
                      </div>
                    </div>
                  </div>
                </div>
                <Slide right delay={.5000}>
                <div className="slider-img"><img src="assets/img/slider/oliver-new-min.png" alt="Oliver" /></div>
                </Slide>
               <Slide left delay={.6000}>
               <div className="slider-img slider-img2 wow slideInRightS"><img src="assets/img/slider/slider_img011.png" alt="Drake_androids" /></div>
               </Slide>
                <div className="slider-circle-shape"><img src="assets/img/slider/slider_circle.png" alt="" className="rotateme" /></div>
              </div>
              <div className="single-slider slider-bg slider-style-two" style={{backgroundImage: 'url(assets/img/slider/slider_bg1.jpg)'}}>
                <div className="container-fluid container-full-padding">
                  <div className="row">
                    <div className="col-xl-6 col-lg-7 col-md-11">
                      <div className="slider-content">
                        <Fade up delay={.4000}>
                        <h6>The Clock</h6>
                        </Fade>
                        <Fade up delay={.5000}>
                        <h2 >Is <span>Ticking</span></h2>
                        </Fade>
                        <Fade up delay={.5000}>
                        <p></p>
                        </Fade>
                        <Fade up delay={.4000}>
                        </Fade>
                      </div>
                    </div>
                  </div>
                </div>
                <Slide right delay={.4000}>
                <div className="slider-img"><img src="assets/img/slider/oliver-new-min.png" alt="" /></div>
                </Slide>
                <Slide left delay={.4000}>
                <div className="slider-img slider-img2"><img src="assets/img/slider/oliver-new-min.png" alt="" /></div>
                </Slide>
                <div className="slider-circle-shape"><img src="assets/img/slider/slider_circle.png" alt="" className="rotateme" /></div>
              </div>
            </Slider>
          </section>
  )
}

export default SliderTwo